/**
 * Статус оплаты **заказа целиком** — `order.payment_status` и параметр отбора
 * `payment_statuses`.
 *
 * `canceled` добавлен в PAR-5189: замер выдачи v2 на `par-5087` дал `not_paid` —
 * 25 024 заказа, `paid` — 23 321, `canceled` — 606, вместе ровно весь список.
 * Остальные значения, которые спека перечисляет для фильтра (`error`, `refund`,
 * `wait_for_commit`, `approved`…), — статусы отдельного платежа, у заказов их
 * нет ни одного, и предлагать их в фильтре значило бы предлагать пустые выборки.
 */
export enum PaymentStatusesEnum {
  NOT_PAID = 'not_paid',
  PAID = 'paid',
  CANCELED = 'canceled'
}

export const localizedPaymentStatuses: Record<PaymentStatusesEnum, string> = {
  [PaymentStatusesEnum.NOT_PAID]: 'Не оплачен',
  [PaymentStatusesEnum.PAID]: 'Оплачен',
  [PaymentStatusesEnum.CANCELED]: 'Отменен'
};
